import React from "react";
import { Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import AppState from "../../store/AppState";
import { makeStyles, createStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import CustomDialog from "../common/DialogContainer";
import ButtonComponent from "../common/ButtonComponent";
import { selectIsModalOpen } from "../../store/modal/ModalSelectors";
import { setModalState } from "../../store/modal/ModalActions";
import { logout } from "../../services/UserService";

const useStyles = makeStyles(() =>
  createStyles({
    dialogAction: {
      width: "100%",
      textAlign: "end",
      margin: "20px 20px 10px",
    },
    divMessage: {
      marginTop: "5px",
    },
  }),
);

export const LogoutConfirmationModalId = "LogoutConfirmationModal";

const LogoutConfirmationModal = () => {
  const classes = useStyles();
  const intl = useIntl();

  const dispatch = useDispatch();
  const isModalOpen = useSelector((state: AppState) =>
    selectIsModalOpen(state, LogoutConfirmationModalId),
  );

  const handleClose = () => {
    dispatch(setModalState(LogoutConfirmationModalId, false));
  };

  const handleContinue = () => {
    logout();
    handleClose();
  };

  const logoutConfirmationTitle = () => {
    return (
      <Typography variant="inherit">
        {intl.formatMessage({
          id: "confirmation.modalTitle",
          defaultMessage: "Warning: Unsaved Changes",
        })}
      </Typography>
    );
  };

  const logoutConfirmationContent = () => {
    return (
      <div className={classes.divMessage}>
        <Typography variant="subtitle1">
          {intl.formatMessage({
            id: "logoutConfirmation.alertText",
            defaultMessage:
              "You have unsaved changes. Are you sure you want to logout without saving your changes?",
          })}
        </Typography>
      </div>
    );
  };

  const dialogActions = () => {
    return (
      <div className={classes.dialogAction}>
        <ButtonComponent
          color="secondaryButtonColorCTABlue"
          variant="outlined"
          onClick={handleClose}
        >
          {intl.formatMessage({
            id: "general.cancel",
            defaultMessage: "Cancel",
          })}
        </ButtonComponent>
        <ButtonComponent
          color="primary"
          variant="contained"
          onClick={handleContinue}
        >
          {intl.formatMessage({
            id: "logoutConfirmation.continue",
            defaultMessage: "Continue",
          })}
        </ButtonComponent>
      </div>
    );
  };

  return (
    <CustomDialog
      open={isModalOpen}
      onClose={handleClose}
      title={logoutConfirmationTitle()}
      actions={dialogActions()}
      maxWidth={"md"}
    >
      {logoutConfirmationContent()}
    </CustomDialog>
  );
};

export default React.memo(LogoutConfirmationModal);
